import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import scheduledEventKeys from '@/api/queries/scheduleEvents/keyFactory';
import { graphql } from '@/gql';
import {
  LinkFolderEntriesToEventMutation,
  LinkFolderEntriesToEventMutationVariables,
} from '@/gql/graphql';

const LinkFolderEntriesToEvent = graphql(`
  mutation LinkFolderEntriesToEvent($input: LinkFolderEntriesToEventInput!) {
    linkFolderEntriesToEvent(input: $input)
  }
`);

const useLinkFolderEntriesToEvent = (args: {
  eventId: string;
  options?: UseMutationOptions<
    LinkFolderEntriesToEventMutation,
    unknown,
    LinkFolderEntriesToEventMutationVariables['input']
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(LinkFolderEntriesToEvent, {
        input,
      });
    },
    onSuccess: () => {
      if (args?.eventId) {
        void queryClient.invalidateQueries({
          queryKey: scheduledEventKeys.scheduledEvent(args.eventId),
        });
      }
    },
    ...args?.options,
  });
};

export default useLinkFolderEntriesToEvent;
